<template>
    <div id="multiple-choice">
        <div class="options">
            <button v-on:click="optionClick" class="ui button option" v-for="option in boosterData.options" :key="option" v-bind:class="{active: option == selectedLabel, selectedCorrect: option == selectedLabel && correct == true, selectedIncorrect: option == selectedLabel && correct == false}">{{ option }}</button>
        </div>
        <FeedbackBox v-bind:correct="correct" v-bind:incorrect="incorrect" v-bind:message="selectedFeedback" />
    </div>
</template>
<script>
import FeedbackBox from '../FeedbackBox.vue'
export default {
    name: 'MultipleChoice',
    props: ['boosterData', 'selectedOption', 'leaderboards', 'api', 'boosterId', 'learnerId', 'programId'],
    components: { FeedbackBox },
    data() {
        return {
            correct: false,
            incorrect: false,
            selectedFeedback: '',
            selectedLabel: '',
            correctLabel: '',
            selection: 0,
            pointsEarned: 0
        }
    },
    mounted() {
        if (this.selectedOption == this.boosterData.correctAnswer) {
            this.correct = true
            this.incorrect = false
            if (this.leaderboards) {
                this.pointsEarned = 5;
                this.$bubble('earnedPoints', 5)
            }
            
            
        }
        else {
            this.correct = false
            this.incorrect = true
        }
        this.selection = this.selectedOption
        this.selectedLabel = this.boosterData.options[this.selection - 1]
        this.correctLabel = this.boosterData.options[this.boosterData.correctAnswer - 1]
        this.selectedFeedback = this.boosterData.feedback[this.selection - 1]

        if (this.api) {
            this.api.post('/api/event', {
                code: 301,
                lid: this.learnerId,
                pid: this.programId,
                bid: this.boosterId,
                submission: this.selectedOption,
                correct: this.selectedOption == this.boosterData.correctAnswer
            })
        }
    },
    methods: {
        optionClick: function(event){ 
            var option = event.target.textContent
            this.selectedLabel = option;
            
            for (let a = 0; a < this.boosterData.options.length; a++) {
                if (this.boosterData.options[a] == option) {
                    this.selection = a + 1;
                }
            }
            if (option == this.correctLabel) {
                this.correct = true
                this.incorrect = false

            }
            else {
                this.correct = false;
                this.incorrect = true
            }
            this.selectedFeedback = this.boosterData.feedback[this.selection - 1]
        }
    }
}
</script>
<style scoped>
.options {
    margin-top: 15px;
}
.options button {
    display: block;
    margin-bottom: 15px;
}
.selectedCorrect.active {
    background-color: #5cb85c;
    color: #FFF;
}
.selectedIncorrect.active {
    background-color: #d9534f;
    color: #FFF;
}
.selectedCorrect:hover {
    background-color: #5cb85c;
    color: #FFF;
}
.selectedIncorrect:hover {
    background-color: #d9534f;
    color: #FFF;
}
.selectedCorrect.active:hover {
    background-color: #5cb85c;
    color: #FFF;
}
.selectedIncorrect.active:hover {
    background-color: #d9534f;
    color: #FFF;
}
@media (max-width: 640px) {
    .ui.button.option {
        width: 100% !important;
    }
    .options {
        padding-top: 50px;
    }
}
</style>